import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api, { errMsg } from "@/lib/api";

const inp = "h-10 w-full border rounded-lg px-3 text-sm";

export const ConvertDialog = ({ u, onClose, onDone }) => {
  const [f, setF] = useState({ name: "", email: "", password: "", role: "member" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/api/admin/mystery/${u.id}/convert`, f);
      toast.success(`${data.name} is now a real ${data.role === "sales_rep" ? "sales rep" : "member"} account${data.follows_converted ? ` · ${data.follows_converted} follows now count as normal followers` : ""}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ms-convert-dialog">
        <DialogHeader><DialogTitle>Convert {u.screen_name} to a staff account</DialogTitle>
          <DialogDescription>Enter the staff member's real name and email. They can log in right away with the password you set. Their follows lose the Bloggers label.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <input value={f.name} onChange={set("name")} placeholder="Staff member's real full name" className={inp} data-testid="ms-convert-name" />
          <input value={f.email} onChange={set("email")} type="email" placeholder="Their real email" className={inp} data-testid="ms-convert-email" />
          <input value={f.password} onChange={set("password")} type="text" placeholder="Password (8+ characters)" className={inp} data-testid="ms-convert-password" />
          <select value={f.role} onChange={set("role")} className={inp} data-testid="ms-convert-role"><option value="member">Regular member (just follows)</option><option value="sales_rep">Sales rep</option></select>
          <button onClick={save} disabled={busy || f.name.trim().length < 2 || !f.email.includes("@") || f.password.length < 8} className="h-10 w-full rounded-full bg-slate-900 text-white text-sm font-bold disabled:opacity-40" data-testid="ms-convert-save">{busy ? "Converting…" : "Convert account"}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
